<template>
    <div>
        <div class="px-4">
            <ul class="my-3 mx-auto bg-gray-50 rounded-lg text-center">
                <li :class="{'bg-brand-blue-dark text-white' : selectedTitle == title}" class="inline-block p-3 m-1 rounded-lg border border-gray-200 hover:bg-brand-blue hover:text-white" v-for="title in tabTitles" :key="title" @click="selectedTitle = title">{{ title }}</li>
            </ul>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import { ref, provide } from 'vue';

export default {
    setup(props, { slots }) {
        const tabTitles = ref(slots.default().map((tab) => tab.props.title));
        const selectedTitle = ref(tabTitles.value[0]);

        provide('selectedTitle', selectedTitle);

        return {
            selectedTitle,
            tabTitles,
        };
    },
};
</script>
